import type { ReactNode } from "react";
import type { TicketType } from "../api/types";
import { AlertTriangle, MessagesSquare, PenLine } from "../compose/Icon";

/**
 * The comment-type glyph (design §1.4 review semantics): PenLine = suggestion,
 * AlertTriangle = request-for-change, MessagesSquare = comment. Shared by the
 * tickets LIST rows (`Tickets.tsx`) and the KANBAN cards (`KanbanCard.tsx`) so
 * the type hue + glyph reads identically across both views — no re-solved map.
 */
export function ticketTypeIcon(type: TicketType, size = 15): ReactNode {
  switch (type) {
    case "suggestion":
      return <PenLine size={size} strokeWidth={1.5} />;
    case "request-for-change":
      return <AlertTriangle size={size} strokeWidth={1.5} />;
    default:
      return <MessagesSquare size={size} strokeWidth={1.5} />;
  }
}
